const susceptibilityStatusLabels = {
    'CONDENSATE RISK': {
        label: "CONDENSATE RISK",
        color: "rgba(75, 120, 170, 1)"
    },
    'AMBER': {
        label: "AMBER",
        color: "rgba(255, 177, 91, 1)"
    },
    'GREEN': {
        label: "GREEN",
        color: "rgba(0,133,87,1)"
    },
};

const staticDynamicLabels = {
    'Real-Time': {
        label: "Real-Time",
        color: "rgba(0,133,87,1)"
    },
    'Static': {
        label: "Static",
        color: "rgba(255, 177, 91, 1)"
    },
};


const condensateRiskLabels = {
    'Pending': {
        label: "Pending",
        color: "rgba(255, 177, 91, 1)"
    },
    'Resolved': {
        label: "Resolved",
        color: "rgba(0,133,87,1)"
    },
};

export const getInitialData = (
  susceptibilityStatusSummary,
  staticDynamicSummary,
  condensateRiskAssessmentSummary,
  setSusceptibilityStatusDataToPlot,
  setStaticDynamicDataToPlot,
  setCondensateRiskDataToPlot
) => {
  const susceptibilityStatusData = {
    labels: [],
    values: [],
    hole: 0.6,
    hoverinfo: 'label',
    marker: {
      colors: [],
      size: 1000,
      line: {
        color: "rgba(28, 28, 28, 0.38)",
        width: [1, 1, 0]
      }
    },
    type: "pie"
  };

  susceptibilityStatusSummary?.category?.forEach((cat, index) => {
    const count = susceptibilityStatusSummary.count[index];
    susceptibilityStatusData.labels.push(`${susceptibilityStatusLabels[cat]?.label || cat}:${count}`);
    susceptibilityStatusData.values.push(count);
    susceptibilityStatusData.marker.colors.push(susceptibilityStatusLabels[cat]?.color || null);
  });

  setSusceptibilityStatusDataToPlot(susceptibilityStatusData);

  const staticDynamicData = {
    labels: [],
    values: [],
    hole: 0.6,
    hoverinfo: 'label',
    marker: {
      colors: [],
      size: 1000,
      line: {
        color: "rgba(28, 28, 28, 0.38)",
        width: [1, 1, 0]
      }
    },
    type: "pie"
  };

  staticDynamicSummary?.category?.forEach((event, index) => {
    const count = staticDynamicSummary.count[index];
    staticDynamicData.labels.push(`${staticDynamicLabels[event]?.label || event}:${count}`);
    staticDynamicData.values.push(count);
    staticDynamicData.marker.colors.push(staticDynamicLabels[event]?.color || null);
  });

  console.log("Static Dynamic Data prepared for plotting:", staticDynamicData);
  setStaticDynamicDataToPlot(staticDynamicData);

  const condensateRiskData = {
    labels: [],
    values: [],
    hole: 0.6,
    hoverinfo: 'label',
    marker: {
      colors: [],
        size: 1000,
        line: {
            color: "rgba(28, 28, 28, 0.38)",
            width: [1, 1, 0]
        }
    },
    type: "pie"
  };

  condensateRiskAssessmentSummary?.category?.forEach((event, index) => {
    const count = condensateRiskAssessmentSummary.count[index];
    condensateRiskData.labels.push(`${condensateRiskLabels[event]?.label || event}:${count}`);
    condensateRiskData.values.push(count);
    condensateRiskData.marker.colors.push(condensateRiskLabels[event]?.color || null);
  });

  setCondensateRiskDataToPlot(condensateRiskData);

};

export const updateColorsForUnmatchedLabels = (dataToPlot, targetLabel, type, setFilterType, applyPieFilters) => {
    if (dataToPlot) {
        const updatedColors = dataToPlot.labels.map((label, index) => {
            if (label.includes(targetLabel)) {
                if (type === "susceptibilityStatus") {
                    setFilterType("susceptibilityStatus");
                    applyPieFilters("susceptibilityStatus", targetLabel);
                    return susceptibilityStatusLabels[targetLabel].color;
                }
                if (type === "staticDynamic") {
                    setFilterType("staticDynamic");
                    applyPieFilters("staticDynamic", targetLabel);
                    return staticDynamicLabels[targetLabel].color;
                }

                if (type === "condensateRisk") {
                    setFilterType("condensateRisk");
                    applyPieFilters("condensateRisk", targetLabel);
                    return condensateRiskLabels[targetLabel].color;
                }
            }
            return 'D9D9D9'; // Change color to grey
        });

        return {
            ...dataToPlot,
            marker: {
                ...dataToPlot.marker,
                colors: updatedColors,
            },
        };
    }
};

export const clickFilterHandler = (pieData, susceptibilityStatusDataToPlot, staticDynamicDataToPlot, condensateRiskDataToPlot, setSusceptibilityStatusDataToPlot, setStaticDynamicDataToPlot, setCondensateRiskDataToPlot, updateColorsForUnmatchedLabels) => {
    const splitToArray = (id) => id.split(":");
    const targetLabel = splitToArray(pieData.points[0].label)[0];

    const updatedSusceptibilityStatusData = updateColorsForUnmatchedLabels(susceptibilityStatusDataToPlot, targetLabel, "susceptibilityStatus");
    setSusceptibilityStatusDataToPlot(updatedSusceptibilityStatusData);

    const updatedStaticDynamicData = updateColorsForUnmatchedLabels(staticDynamicDataToPlot, targetLabel, "staticDynamic");
    setStaticDynamicDataToPlot(updatedStaticDynamicData);

    const updatedCondensateRiskData = updateColorsForUnmatchedLabels(condensateRiskDataToPlot, targetLabel, "condensateRisk");
    setCondensateRiskDataToPlot(updatedCondensateRiskData);
};